import styled from "styled-components";

const StyledRect = styled.rect`
  fill: ${(props) => props.theme.backgroundColor};
`
const StyledCircle = styled.circle`
  fill: none;
`

const Rings = ({planetcolors, ringNums}) => {
  return (
    <g>
      <StyledCircle stroke={`${planetcolors.texture}99`} strokeWidth={ringNums.inner.width} cx="2000" cy="2000" r={ringNums.inner.diameter}/>
      <StyledCircle stroke={`${planetcolors.ocean}99`} strokeWidth={ringNums.middle.width} cx="2000" cy="2000" r={ringNums.middle.diameter}/>
      <StyledCircle stroke={`${planetcolors.background}99`} strokeWidth={ringNums.outer.width} cx="2000" cy="2000" r={ringNums.outer.diameter}/>
      <g>
        <StyledRect x="613.98" y="1199.07" width="151.94" height="151.94"/>
        <path d="M756.51,1209.07V1341.6H624V1209.07H756.51m10-10H614V1351.6H766.51V1199.07Z"/>
        <path d="M685.5,1247.71H668.25V1236c14,0,18.89-3,22.64-13.2H702v105H685.5Z"/>
      </g>
    </g>
  )
}

export default Rings
